export enum ExchangeModalPaperFormKeys {
  QUANTITY = 'quantity',
  AUTHORIZATION_ID = 'authorizationId',
  DELIVERY_ADDRESS = 'paperVoucherDeliveryAddress',
  USE_MAIN_ADDRESS = 'useMainAddressForPaperVoucherDelivery',
}
